var map = {
	"./app.js": "WSTi",
	"./publicData.js": "vaRo",
	"./tagsView.js": "Zq5Z",
	"./user.js": "bREw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gNcp";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules nonrecursive \.js$
// module id = gNcp
// module chunks = 23